module.exports = __webpack_public_path__ + "vue-technologies.nhWHg-37.svg";